import { Link } from "react-router-dom";
import type { Title } from "@/mocks/titles";

interface TitleCardProps {
  title: Title;
  className?: string;
}

export default function TitleCard({ title, className = "" }: TitleCardProps) {
  return (
    <Link
      to={`/detail/${title.id}`}
      className={`group block rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-secondary-100">
        <img
          src={title.cover}
          alt={`${title.name} - 蘑菇TV影视封面`}
          title={`${title.name} + 蘑菇TV`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1 bg-black/55 backdrop-blur-sm rounded-md px-2 py-1">
          <i className="ri-star-fill text-primary-400 text-xs"></i>
          <span className="text-xs font-semibold text-background-50">
            {title.rating > 0 ? title.rating.toFixed(1) : "暂无"}
          </span>
        </div>
        <div className="absolute bottom-2 right-2 bg-black/55 backdrop-blur-sm rounded-md px-2 py-1">
          <span className="text-[11px] text-background-100">{title.updateInfo}</span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="font-heading font-semibold text-sm text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
          {title.name}
        </h3>
        <p className="mt-1 text-xs text-foreground-500 truncate">
          {title.actors.join(" / ")}
        </p>
        <div className="mt-2 flex items-center gap-2 text-[11px] text-foreground-500">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700">
            {title.region}
          </span>
          <span>{title.year}</span>
        </div>
      </div>
    </Link>
  );
}